module.exports = __webpack_public_path__ + "static/img/25.a0672873.jpg";